import { get } from '../../../utils/get';
export var getEventMonth = function (item) {
    if (item === void 0) { item = {}; }
    var startDate = get(item, 'event.scheduling.config.startDate');
    if (!startDate) {
        return;
    }
    return new Date(startDate).toLocaleString('default', { month: 'long' });
};
